import axios from "axios";

// The v3 endpoints pick their success/failure redirect URLs from the Platform
// header, which the backend matches lowercase — the global default is "WEB", so
// it has to be overridden per request or 3DS returns nowhere. `silentError`
// suppresses the interceptor's generic toast: these callers render the 422
// `errors` map themselves.
const FLOW_REQUEST_CONFIG = { headers: { Platform: "web" }, meta: { silentError: true } };

export default class sessionsClient {
  static async getVideoRoom(id) {
    return await axios.get("/api/client/rooms/" + id);
  }

  static async getChatRoom(id) {
    return await axios.get("/api/client/rooms/" + id);
  }

  static async getAllSessions() {
    return await axios.get("/api/client/sessions");
  }

  static async getPastSessionsPaginated(page) {
    return await axios.get("/api/client/sessions/past?status=booked&page=" + page);
  }

  static async getFeedbackQuestions() {
    return await axios.get("/api/feedback-questions");
  }

  static async createOrder(order) {
    return await axios.post("/api/client/v2/orders", order);
  }

  static async getOrder(id) {
    return await axios.get(`/api/client/v2/orders/${id}`);
  }

  static async checkCoupon(sessionID, coupon) {
    return await axios.get(`/api/client/v2/session/${sessionID}/coupon?promo_code=${coupon}`);
  }

  static async getPricePackages(id) {
    return await axios.get(`/api/client/therapists/${id}/product-prices`);
  }

  static async createPackageOrder(order) {
    return await axios.post("api/client/package-orders", order);
  }

  static async checkPackages() {
    return await axios.get("api/client/package-orders");
  }

  static async bookSessionByPackage(session) {
    return await axios.post("api/client/v2/session-package-orders", session);
  }

  static async getOrderPackages(id) {
    return await axios.get(`/api/client/package-orders/${id}`);
  }

  // Checkout.com Flow: the backend opens a PaymentSession and returns
  // everything the Flow SDK needs. No card data or token is sent from here.
  static async createPaymentSession(payload) {
    return await axios.post("/api/client/v3/payment-sessions", payload, FLOW_REQUEST_CONFIG);
  }

  static async createPackagePaymentSession(payload) {
    return await axios.post("/api/client/v3/package-payment-sessions", payload, FLOW_REQUEST_CONFIG);
  }

  static async getAvailablePayments(amount) {
    return await axios.get(`/api/client/payment-modes?amount=${amount}`);
  }
}
